// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/dev/bibleapp/shiyuadmin/frontend/shiyu-admin-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import SettingOutlined from 'D:/dev/bibleapp/shiyuadmin/frontend/shiyu-admin-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
import AppstoreOutlined from 'D:/dev/bibleapp/shiyuadmin/frontend/shiyu-admin-web/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/AppstoreOutlined';
export default { SmileOutlined, SettingOutlined, AppstoreOutlined };
